// extracted by mini-css-extract-plugin
module.exports = {"matrix-table--pad3":"k_q ml-3","matrix-table--pad4":"k_r ml-5","matrix-table__title":"k_s","matrix-table__true":"k_t","matrix-table__false":"k_v"};